import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import ModuleList from '../../../layout/ModuleList';
import {
  DISCOUNT_CODE_AUTHORIZER_PATH,
  NEW_DISCOUNT_CODE_AUTHORIZER_PATH,
} from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { DISCOUNT_CODE_AUTHORIZER_COLUMNS } from '../../../../config/columns';
import {
  clearDiscountCodeAuthorizers,
  getDiscountCodeAuthorizers,
} from '../../../../actions/sales/DiscountCodeAuthorizer';

export const DiscountCodeAuthorizers = ({
  breadcrumbs,
  discountCodeCategories,
  loading,
  dispatchGetDiscountCodeAuthorizers,
  dispatchClearDiscountCodeAuthorizers,
}) => {
  useLayoutEffect(() => () => dispatchClearDiscountCodeAuthorizers(), []);

  const data = discountCodeCategories.get('content') || [];
  const pages = discountCodeCategories.get('totalPages') || null;
  const defaultPageSize =
    discountCodeCategories.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Autorizadores de Códigos de Descuento"
      breadcrumbs={breadcrumbs}
      buttonPath={NEW_DISCOUNT_CODE_AUTHORIZER_PATH}
      tableStructure={{
        columns: DISCOUNT_CODE_AUTHORIZER_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetDiscountCodeAuthorizers,
        modelPath: DISCOUNT_CODE_AUTHORIZER_PATH,
        loading,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetDiscountCodeAuthorizers: getDiscountCodeAuthorizers,
  dispatchClearDiscountCodeAuthorizers: clearDiscountCodeAuthorizers,
};

const mapStateToProps = ({ SalesUnit }) => ({
  breadcrumbs: [
    ...SalesUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Autorizadores de Códigos de Descuento',
      href: DISCOUNT_CODE_AUTHORIZER_PATH,
    },
  ],
  discountCodeCategories: SalesUnit.DiscountCodeAuthorizer.getIn([
    'all',
    'content',
  ]),
  loading: SalesUnit.DiscountCodeAuthorizer.getIn(['all', 'loading']),
});

DiscountCodeAuthorizers.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  discountCodeCategories: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetDiscountCodeAuthorizers: PropTypes.func.isRequired,
  dispatchClearDiscountCodeAuthorizers: PropTypes.func.isRequired,
};

DiscountCodeAuthorizers.defaultProps = {
  discountCodeCategories: null,
  loading: false,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DiscountCodeAuthorizers);
